// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import tippy from 'tippy.js';

export default class Tooltip extends WebComponent {
	didMount() {
		let zIndex = 9999;
		if(this.element.closest('.esp')) {
			zIndex = 10002;
		}
    	tippy(this.element, {
			arrow: true,
			theme: 'esp',
			zIndex: zIndex,
			allowHTML: true,
		});
  }
}



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Tooltip.js